import { writable } from 'svelte/store';
import { getLanguage, getUrlParam } from '../helpers/url';
import { isDefinedNotNull } from '../helpers/common';
import V3Factory from '../helpers/V3';
import { industryCategoryGroup, noImage, obxEndpoint, shortname, } from '../helpers/consts';
import { mapCenter } from '../helpers/map';
import './service';
const productStore = writable([]);
const isLoading = writable(false);
export const searched = writable(false);
const V3 = V3Factory(obxEndpoint, shortname);
let cachedCriteria;
function withComma(value) {
    if (value) {
        return `, ${value}`;
    }
    return '';
}
function cacheCriteria(criteria) {
    if (criteria) {
        cachedCriteria = criteria;
    }
    else {
        criteria = cachedCriteria;
    }
    return criteria;
}
function getRequest(criteria) {
    const filteredDate = criteria.Date || new Date();
    let filteredNights = null;
    let filteredGuests = null;
    let filteredShoppingCategory = null;
    if (isDefinedNotNull(criteria.Night) && criteria.Type === 0) {
        filteredNights = criteria.Night;
    }
    if (isDefinedNotNull(criteria.Guest)) {
        filteredGuests = criteria.Guest;
    }
    const language = `${getLanguage() || 'ja'}-JP`;
    let request = {
        Language: `${language}`,
        Availability: {
            MergeMethod: 2,
            Specific: { Date: filteredDate, Duration: filteredNights || 1 },
            Window: null,
        },
        Output: {
            CommonContent: {
                All: true,
            },
            Settings: true,
            Features: true,
            Rating: true,
            Availability: {
                StartDate: filteredDate,
                NumberOfDays: 7,
                MergeMethod: 2,
                FlagCampaign: true,
            },
            Reviews: {
                IncludeFullDescription: true,
                IncludeShortReview: true,
                MaxReturnCount: 10,
                MaxReturnCountSpecified: true,
            },
            AdvancedContent: true,
        },
        Filter: {
            Type: 'Service',
            MustBeInAdCampaign: true,
            MustBeInDealCampaign: false,
            Bookability: {
                BlockUnavailableResults: true,
                GuestsCapability: filteredGuests,
                IncludeOnRequest: true,
                IsBookable: true,
                NightsCapability: filteredNights,
            },
        },
        Campaign: {
            AdCampaignCode: '',
            DealCampaignCode: '',
        },
    };
    if (criteria.Id) {
        request.Filter.Ids = [criteria.Id];
        request.Output.Availability.LowestRateOnly = false;
        request.Output.Children = {
            Output: {
                CommonContent: {
                    All: true,
                },
                Features: true,
                Rating: true,
                Reviews: {
                    IncludeFullDescription: true,
                    IncludeShortReview: true,
                    MaxReturnCount: 10,
                    MaxReturnCountSpecified: true,
                },
                Availability: {
                    StartDate: filteredDate,
                    NumberOfDays: 7,
                    MergeMethod: 2,
                    FlagCampaign: true,
                },
            },
            Children: {
                Filter: {
                    Ids: null,
                    Type: 4,
                    Bookability: {
                        BlockUnavailableResults: true,
                        GuestsCapability: filteredGuests,
                        IncludeOnRequest: true,
                        IsBookable: true,
                        NightsCapability: filteredNights,
                    },
                },
            },
        };
        if (isDefinedNotNull(criteria.ShoppingCategory)) {
            request.Filter.Names = ['%' + criteria.ShoppingCategory + '%'];
            request.Output.Children.Children.Filter.Names = [
                '%' + criteria.ShoppingCategory + '%',
            ];
        }
    }
    return request;
}
async function search(criteria = null, shortname) {
    /* Nara custom logic */
    const selectedType = getUrlParam('type');
    if (selectedType && selectedType === industryCategoryGroup.isRestaurant) {
        //change distributor
        V3.setDistributor('NaratabiB');
    }
    /* Nara custom logic */
    criteria = cacheCriteria(criteria);
    isLoading.set(true);
    const response = await V3.search(getRequest(criteria), shortname);
    const services = prepare(response.Entities);
    let products = [];
    if (response.Entities.length > 0) {
        products = prepare(response.Entities[0].Children, false);
        productStore.set(products);
    }
    isLoading.set(false);
    searched.set(true);
}
function prepare(services, parent = true) {
    return services.map(function (service, index) {
        return {
            Id: service.Id,
            Name: service.Name,
            Thumbnail: service.Images && service.Images.length
                ? service.Images[0].Url
                : noImage,
            Images: service.Images && service.Images.length
                ? service.Images.map((img) => img.Url)
                : [noImage],
            Desc: service.ShortDescription || parent
                ? service.LongDescription.substr(0, 200) + ' ...'
                : service.LongDescription,
            Code: service.Code,
            Rating: service.Rating,
            MinimumStayDuration: service.MinimumStayDuration,
            LongDesc: service.LongDescription,
            Price: Math.round(service.Availability.Calendar.LowestRate),
            Phone: service.MainPhone
                ? ('0' + service.MainPhone.AreaCode + service.MainPhone.Number)
                : null,
            Fax: service.Facsimile || '',
            Website: service.Website,
            PublicEmail: service.PublicEmail,
            OnRequestOnly: service.OnRequestOnly,
            Address: service.PhysicalAddress
                ?
                    service.PhysicalAddress.PostCode +
                        withComma(service.PhysicalAddress.City) +
                        withComma(service.PhysicalAddress.Line1) +
                        withComma(service.PhysicalAddress.Line2)
                : null,
            Geocode: {
                latitude: service.HasGeocodes
                    ? service.Geocodes[0].Geocode.Latitude
                    : mapCenter.lat + index * 0.2,
                longitude: service.HasGeocodes
                    ? service.Geocodes[0].Geocode.Longitude
                    : mapCenter.lng + index * 0.2,
            },
            Type: service.IndustryCategoryGroups[0],
            TypeName: getTypeName(service.IndustryCategoryGroups[0]),
        };
    });
}
function getTypeName(type) {
    let name = '';
    switch (type) {
        case 0:
            name = 'Accommodation';
            break;
        case 1:
            name = 'Activity';
            break;
        case 2:
            name = 'Restaurant';
            break;
        case 3:
            name = 'Produce';
            break;
        default:
            name = 'Accommodation';
    }
    return name;
}
function getNextPage() {
    search(null, true);
}
let store;
export default store = {
    search,
    getNextPage,
    data: {
        subscribe: productStore.subscribe,
        isLoading: { subscribe: isLoading.subscribe },
    },
};
